import { Component, OnInit } from '@angular/core';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {DoraProperty} from '../../Decorators/Decorator';
import {DataType} from '../../pusblisher/ipublisher';
import {DataGrid} from '../../DoraData/data-grid';
import {WidgetBaseComponent} from '../widget-base/widget-base.component';
import {DataSeries} from '../../DoraData/data-series';
import {forEach} from '@angular/router/src/utils/collection';
import {timer} from 'rxjs';
import {DoraNumber} from '../../Utility/dora-number';

@Component({
  selector: 'dora-series-value',
  templateUrl: './dora-series-value.component.html',
  styleUrls: ['./dora-series-value.component.scss']
})
export class DoraSeriesValueComponent extends WidgetBaseComponent {

  @DoraProperty
  private seriesId = '';

  @DoraProperty
  // tslint:disable-next-line:variable-name
  private animation_time = 2000;

  @DoraProperty
  private outputFormat = '###,###';

  @DoraProperty
  private unitOnRight = true;

  private dataSeries: DataSeries = null;

  private startDate: Date = null;
  private startValue = 0.0;

  private endDate: Date = null;
  private endValue = 0.0;

  private currentValue = '';
  private dateGap = 0.0;

  onParameterInjectedFinished() {
    super.onParameterInjectedFinished();


    this.readData();
  }
  private  readData(): void {
    if (this.seriesId === null || this.seriesId === '') {
      return;
    }
    // Read Preselect table
    this.read([this.seriesId], DataType.HISTORICAL).subscribe((data: any) => {
      if (data !== null) {
        this.dataSeries = (data as DataSeries);
        this.onNewData();
      }
    });
  }

  private onNewData(): void {
    const now: Date = new Date();
    this.startDate = this.endDate = null;
    let i;
    for (i = 0; i < this.dataSeries.DataRows.length; i++) {
      const dataRow = this.dataSeries.DataRows[i];

      const rowTimestamp = (dataRow.getTuplaValue('Timestamp', '') as Date);

      if (rowTimestamp === null) {
        return;
      }

      if (rowTimestamp >= now ) {
        this.endDate = rowTimestamp;
        this.endValue = dataRow.getTuplaValue('Close', '');
        break;
      }

      if (rowTimestamp <= now) {
        this.startDate = rowTimestamp;
        this.startValue = dataRow.getTuplaValue('Close', '');
      }
    }
    if (this.startValue !== 0 && this.endValue !== 0) {
      this.dateGap = this.endDate.getTime() - this.startDate.getTime();

      this.buildData();
      this.checkTimer();
    }
  }

  private buildData(): void {
    let currentValueNumber = 0.0;
    if (this.startValue !== 0 && this.endValue !== 0) {
      const now = new Date().getTime();
      const diffValue = this.endValue - this.startValue;
      currentValueNumber = this.startValue + (diffValue * (now - this.startDate.getTime()) / this.dateGap );
    } else {
      currentValueNumber = 0.0;
    }

    this.currentValue = DoraNumber.formatNumber(currentValueNumber, null, this.outputFormat);
  }

  private checkTimer(): void {
    const myTime = timer(this.animation_time);
    myTime.subscribe(value => {
      this.buildData();
      this.checkTimer();
    });
  }


}
